import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix EUR icon. Exported from Figma (Bombiix 2026). */
const EURIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M13.667 6.33398C13.3337 6.00065 12.3337 5.33398 10.667 5.33398C8.2456 5.33398 7.12712 6.85406 6.78576 8.66732M6.78576 8.66732C6.70419 9.1006 6.66699 9.55063 6.66699 10.0007C6.66699 10.4507 6.70419 10.9007 6.78576 11.334C7.12712 13.1472 8.2456 14.6673 10.667 14.6673C12.3337 14.6673 13.3337 14.0007 13.667 13.6673M6.78576 8.66732H4.66699M6.78576 8.66732H11.3337M6.78576 11.334H4.66699H11.3337"
      stroke="currentColor"
    />
  </svg>
);

export default EURIcon;
